import React, { Dispatch, SetStateAction, useMemo } from 'react'

import { Button, Grid, Typography } from '@barracuda-internal/bds-core'

import { useFormatMessage } from 'lib/localization'
import { FormSpacer } from 'components/libs/layout/pages/pageLayout'
import styles from 'components/pages/inboundSettings/inboundSettingsStyles'
import DomainTable from 'components/libs/domainTable/DomainTable'
import { useIsReadonly } from 'lib/hooks/useIsReadonly'
import { useBrtsExemptLogic } from './useBrtsExemptLogic'

const BASE_I18N_KEY = 'ess.inbound_settings.reputation'
const BASE_INBOUND_I18N_KEY = 'ess.inbound_settings'

export interface BrtsExemptProps {
  delegateDirtyFormState: Dispatch<SetStateAction<boolean>>
}

const BrtsExempt: React.FC<BrtsExemptProps> = (props: BrtsExemptProps) => {
  const isReadonly = useIsReadonly()
  const formatMessage = useFormatMessage(BASE_I18N_KEY)
  const formatInboundMessage = useFormatMessage(BASE_INBOUND_I18N_KEY)
  const inboundClasses = styles()
  const [state, eventHandlers] = useBrtsExemptLogic()

  return useMemo(
    () => (
      <Grid container data-testid="brts-exempt-section">
        <Typography variant="h4">{formatMessage('brts_exemptions')}</Typography>
        <FormSpacer />
        <Button
          className={inboundClasses.bulkEdit}
          onClick={eventHandlers.onBulkEdit}
          variant="contained"
          size="small"
          data-testid="bulk-button-brts"
          disabled={isReadonly}
        >
          {formatInboundMessage('bulk_edit')}
        </Button>
        <DomainTable
          data={state.tableData}
          onAddItem={eventHandlers.onAddItem}
          onRemoveItem={eventHandlers.onRemoveItem}
          shouldHandleEmail
          isLoading={state.isLoading}
          data-testid="brts-exempt-table"
          delegateDirtyFormState={props.delegateDirtyFormState}
        />
      </Grid>
    ),
    [
      formatMessage,
      formatInboundMessage,
      inboundClasses.bulkEdit,
      eventHandlers,
      state.tableData,
      state.isLoading,
      isReadonly,
      props.delegateDirtyFormState
    ]
  )
}

export default BrtsExempt
